export class User
{
  avatar?: string;
  status?: string;

  id: string | undefined;
  userName: string | undefined;
  fio: string | undefined;
  mainRole: string | undefined;

  countEnter: number | undefined;

  surname: string | undefined;
  name: string | undefined;
  patronymic: string | undefined;

  token?: string;
  isChangePassword: boolean = false;
  password: string | undefined;

  // tbStaffId: string;
  pinfl: string | undefined;
}
